const runOnEnter = (...handlers) => (nextState, replaceState, cb) =>
  Promise.all(handlers.map(handler => new Promise(resolve => handler(nextState, replaceState, resolve))))
    .then(() => cb())
    .catch(cb);

export default runOnEnter;
